import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { FormFieldFileUpload } from '@publishing-engine/domain/types/article';

type IProps = {
  fieldLabels: FormFieldFileUpload['params']['labels'];
  editCallback?: () => void;
};

export const FileEmptyState: React.FC<IProps> = ({ editCallback }) => (
  <Flex flexDirection={'column'}>
    <Flex alignItems="center">
      <Text textStyle="textBody" color="GrayText">
        No data available
      </Text>
    </Flex>
    <Flex>
      {editCallback && <ButtonText onClick={editCallback}>Update</ButtonText>}
    </Flex>
  </Flex>
);
